import { SpotPrice } from "@aws-sdk/client-ec2";

type spotPriceMap = {
  [key in string]: SpotPrice[];
};

export const groupSpotPriceByInstanceType = (spotPrices: SpotPrice[]) => {
  return spotPrices.reduce((acc: spotPriceMap, spotPrice) => {
    if (!spotPrice.InstanceType) {
      return acc;
    }

    if (!acc[spotPrice.InstanceType]) {
      acc[spotPrice.InstanceType] = [spotPrice];
    } else {
      acc[spotPrice.InstanceType].push(spotPrice);
    }

    acc[spotPrice.InstanceType].sort((a, b) => {
      if (Number(a.SpotPrice) < Number(b.SpotPrice)) return -1;
      if (Number(a.SpotPrice) > Number(b.SpotPrice)) return 1;
      return 0;
    });

    return acc;
  }, {});
};
